// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"56b09280","99":"f25c884c","207":"7ab36a29","229":"316b94db","348":"1ca9568f","473":"2a50e044","485":"ebdaa65d","720":"44247a98","839":"4a48953b","930":"41234155"}[chunkId] + ".chunk.js";
};